import { useEffect, useState } from "react"
import { Box, Grid, IconButton, Typography } from "@mui/material"
import { useTheme } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonBasic, TableBase } from "../../components"
import { showModal } from "react-redux-modal-provider";
import AlertDateSalesService from "../../services/alertDateSales.service";
import ModalAlertDateSales from "../../modals/admTicket/ModalAlertDateSales";
import FechaFunction from "../../function/FechaFunction";

const AlertDatesSalesScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const actualizar = async() =>{
        await AlertDateSalesService.getAll({all: true}).then((resp)=>{
            setItems(resp)
        })
    }
    const columns = [
        {
            name: "id_das",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "titulo_das",
            label: "Titulo",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "fechaVentaAviso_das",
            label: "Fecha Venta",
            options: {
                filter: true,
                sort: true,
                customBodyRender:(value, tableMeta, updateValue) => FechaFunction.format(value,'dd-MM-yyyy')
            }
        },
        {
            name: "tipoAvisoHs_das",
            label: "Tipo",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "fechaVisitaPactada_das",
            label: "Fecha Pactada",
            options: {
                filter: true,
                sort: true,
                customBodyRender:(value, tableMeta, updateValue) => FechaFunction.format(value,'dd-MM-yyyy')
            }
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <IconButton aria-label="edit" onClick={()=>onOpenEditar(tableMeta.rowData[0])}>
                                <EditIcon fontSize="medium" sx={{color: isDarkMode ? '#90caf9' : '#0364ff'}} />
                            </IconButton>
                        </Box>
                    </>
                )
            }
        }
    ];
    const onGuardar = () => actualizar();
    const onOpenEditar = (item) => {
        if(item){
            const searchItem = items.find((sItem)=> sItem.id_das === item)
            showModal(ModalAlertDateSales, {item: searchItem, onGuardar: onGuardar});
        }else{
            showModal(ModalAlertDateSales, {onGuardar: onGuardar});
        }
    };
    useEffect(() => {
        actualizar();
        document.title = 'Correo de Alerta - Terceriarizada';
    }, [])


    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', bgcolor: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={3} display='flex' justifyContent='center'>
                <Grid item xs={6}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h2">Correo de Alerta - Terceriarizada</Typography>
                </Grid>
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton="NUEVO"
                        sx={{width: 200, height: 30}}
                        onClick={()=>onOpenEditar()}
                        variant='wk'
                        color="nextStep"
                    />
                </Grid>
                <Grid item xs={12} md={10} mt={2} sx={{marginBottom: 15}}>
                    <TableBase title='Resultados' columns={columns} data={items} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default AlertDatesSalesScreen;